import Vue from 'vue'
import { Tab, Tabbar, TabbarItem, Button, Icon, NavBar, Toast, Field, Calendar, Cell, CellGroup, RadioGroup, Radio, Grid, GridItem, Dialog } from 'vant'

// 全局注册
Vue.use(Dialog)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Calendar)
Vue.use(Field)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Tab)
Vue.use(Tabbar)
Vue.use(Button)
Vue.use(Icon)
